import { render, staticRenderFns } from "./TextareaRich.vue?vue&type=template&id=5755e582&"
import script from "./TextareaRich.vue?vue&type=script&lang=js&"
export * from "./TextareaRich.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports